import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Button,
  Row,
  Col,
  Form,
  Label,
} from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import axios from "axios";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getAllStation } from "../../slices/stations/thunk";
import { updateReservation } from "../../slices/reservations/updatereservation/thunk";
import { postReservation } from "../../slices/reservations/postreservation/thunk";
import { getReservation } from "../../slices/reservations/getreservation/thunk";
import { Loader } from "../Utils/Loader";
import { validationSchema } from "./constants/validationschema";
import { connectorTypeOptions } from "./constants/reservationinitialvalues";
import { evseoptions } from "./constants/reservationinitialvalues";
import { fetchAllOffers } from "../../slices/offer/thunk";
import SelectField from "../Utils/SelectField";
import CommonButton from "../Utils/CommonButton";
import { PAGE_TITLES } from "../Common/constants";
import CommonDateTimePicker from "../Utils/CommonDateTimePicker";
import moment from "moment";
import ViewReservation from "./ViewReservation";
import { formatPhoneNumber } from "../Utils/UtilityFunctions";
import Stepper from "../Common/Stepper";

function CreateReservations() {
  const [searchValue, setSearchValue] = useState("");
  const [storedData, setStoredData] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);
  const [selectedDateTimeStart, setSelectedDateTimeStart] = useState(null);
  const [selectedDateTimeEnd, setSelectedDateTimeEnd] = useState(null);
  const [selectedEVSE, setSelectedEVSE] = useState(null);
  const [selectedConnectorType, setSelectedConnectorType] = useState(null);
  const [reservationData, setReservationData] = useState(null);
  const [isSearchBarVisible, setSearchBarVisible] = useState(false);
  const [enableFormReinitialize, setEnableFormReinitialize] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchFieldError, setSearchFieldError] = useState("");
  const isEdit = location.pathname.includes("update-reservation");
  const isView = location.pathname.includes("view-reservation");
  const isCreate = location.pathname.includes("create-reservation-customer");
  const [loadingData, setLoadingData] = useState(false);
  const reservationIdPath = location.pathname.slice(
    location.pathname.lastIndexOf("/"),
    location.pathname.length
  );
  const reservationIdmain = reservationIdPath.slice(
    1,
    reservationIdPath.length
  );
  const initialValues = {
    idTokenType: "",
    startTime: null,
    endTime: null,
    station: "",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dateTimeFormat = `${
    localStorage.getItem("dateFormat") || "DD MMM YYYY"
  }  hh:mm A`;
  const customerId = reservationData?.customerId;
  const submitReservationData = () => {
    if (!searchValue) {
      setSearchFieldError("Please enter a Customer ID");
      return;
    }

    const stationId = selectedStation ? selectedStation.value : "";
    const idToken = selectedAttribute ? selectedAttribute.value.value : "";
    const type = selectedAttribute ? selectedAttribute.value.name : "";
    const formattedDateTime = selectedDateTimeStart
      ? new Date(selectedDateTimeStart).toISOString().replace(/\.\d{3}Z$/, "Z")
      : "";
    const formattedEndDateTime = selectedDateTimeEnd
      ? new Date(selectedDateTimeEnd).toISOString().replace(/\.\d{3}Z$/, "Z")
      : "";

    const formData = {
      customerId: searchValue,
      stationId: stationId,
      startTime: formattedDateTime,
      endTime: formattedEndDateTime,
      evseId: 0,
      idTokenType: {
        idToken: idToken,
        type: type,
      },
    };

    if (isEdit) {
      formData.reservationId = reservationData?.reservationId;
    }
    const requestBody = JSON.stringify(formData);
    if (isEdit) {
      dispatch(
        updateReservation(requestBody, isEdit, navigate, setLoadingData)
      );
    } else {
      dispatch(postReservation(requestBody, isEdit, navigate, setLoadingData));
    }
  };

  const offerData = useSelector((state) => state.Offer.offer);
  const globalOffers = offerData
    ?.filter((offer) => offer.globalScope)
    .reverse();

  const fetchReservationData = () => {
    setLoadingData(true);
    const url = `${window.env.REACT_APP_GET_CUSTOMER_API}/${customerId}?includeSubscription=true`;
    const accessToken = localStorage.getItem("token");

    let options = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    axios
      .get(url, options)
      .then((response) => {
        setStoredData(response.data);
        setLoadingData(false);
      })
      .catch((error) => {
        setLoadingData(false);
      });
  };

  const fetchOffers = () => {
    dispatch(fetchAllOffers(setLoading));
  };

  useEffect(() => {
    if (isEdit || isView) {
      fetchOffers();
      setSearchBarVisible(true);
      const customerId = reservationData?.customerId;
      if (customerId) {
        fetchReservationData(customerId);
      }
    }
  }, [isEdit, isView, reservationData]);

  useEffect(() => {
    if (!isEdit && !isView) {
      setEnableFormReinitialize(true);
    }
  }, [isEdit, isView]);

  useEffect(() => {
    if (isEdit || isView) {
      dispatch(
        getReservation(
          reservationIdmain,
          setReservationData,
          setSearchValue,
          setSelectedAttribute,
          setSelectedStation,
          setSelectedDateTimeStart,
          setSelectedDateTimeEnd,
          initialValues,
          setLoadingData
        )
      );
    } else {
      setEnableFormReinitialize(true);
      setSearchBarVisible(false);
      setSearchValue("");
      setStoredData(null);
      setSelectedAttribute(null);
      setSelectedStation(null);
      setSelectedDateTimeStart(null);
      setSelectedDateTimeEnd(null);
      setSelectedEVSE(null);
      setSelectedConnectorType(null);
      setReservationData(null);
    }
  }, [dispatch, isEdit, isView]);

  const handleSearch = () => {
    fetchOffers();
    if (!searchValue) {
      setSearchFieldError("Please enter a Customer ID");
      return;
    }
    setLoadingData(true);
    const url = `${window.env.REACT_APP_GET_CUSTOMER_API}/${searchValue}?includeSubscription=true`;
    const accessToken = localStorage.getItem("token");
    let options = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      validateStatus: function (status) {
        return status >= 200 && status <= 505;
      },
    };
    axios
      .get(url, options)
      .then((response) => {
        if (!response?.data?.error) {
          setLoadingData(false);
          setStoredData(response?.data);
        }
        if (response?.data?.error) {
          toast.error(response?.data?.error?.message);
          setStoredData(null);
          setLoadingData(false);
        }
      })
      .catch((error) => {
        setLoadingData(false);
      });
  };
  useEffect(() => {
    dispatch(getAllStation(setLoading));
  }, [dispatch]);

  useEffect(() => {
    if (isCreate && reservationIdPath) {
      const cleanedReservationIdPath = reservationIdPath.substring(1);
      setSearchValue(cleanedReservationIdPath);
    } else {
      setSearchValue("");
      setStoredData(null);
    }
  }, [reservationIdPath]);

  useEffect(() => {
    if (isCreate) {
      handleSearch();
    }
  }, [searchValue]);

  const stations = useSelector((state) => state.Stations.station);

  useEffect(() => {
    if (!storedData) {
      setSelectedAttribute(null);
    }
  }, [storedData]);

  const attributeOptions = storedData?.customerInfo?.attributeList?.map(
    (attribute) => ({
      value: attribute,
      label: attribute.name,
    })
  );

  const updatedStations = stations
    ?.filter(
      (station) =>
        station.stationDetails.status === "Accepted" &&
        station.stationDetails.OCPPVersion === "ocpp2.0.1"
    )
    .map((station) => ({
      label: station.stationDetails.name,
      value: station.stationDetails.stationID,
      ...station,
    }));

  const handleDateTimeChangeStart = (dateStr) => {
    setSelectedDateTimeStart(dateStr);
  };

  const handleDateTimeChangeEnd = (dateStr) => {
    setSelectedDateTimeEnd(dateStr);
  };

  return (
    <React.Fragment>
      {loadingData && <Loader />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={enableFormReinitialize}
        onSubmit={submitReservationData}
      >
        {({
          handleSubmit,
          errors,
          touched,
          values,
          setFieldTouched,
          setFieldValue,
        }) => (
          <Form id="csms" className="needs-validation" onSubmit={handleSubmit}>
            <div className="page-content">
              <Container fluid>
                <BreadCrumb
                  title={
                    isEdit
                      ? PAGE_TITLES.EDIT_RESERVATION
                      : isView
                      ? PAGE_TITLES.VIEW_RESERVATION
                      : PAGE_TITLES.ADD_RESERVATION
                  }
                  pageTitle={PAGE_TITLES.RESERVATION_LIST}
                />
                <Row>
                  <Col lg={12}>
                    {isView ? (
                      <ViewReservation
                        storedData={storedData}
                        values={values}
                        globalOffers={globalOffers}
                        updatedStations={updatedStations}
                      />
                    ) : (
                      <CardBody>
                        <ToastContainer position="top-center" />
                        <div>
                          {isEdit && (
                            <Row>
                              <div className=" mb-2">
                                <p className="rv-page-title fs-5 fw-semibold p-1">
                                  {"Customer ID"}
                                </p>
                              </div>{" "}
                              <Col lg={8}>
                                {" "}
                                <Input
                                  placeholder=""
                                  value={storedData?.customerInfo?.customerId}
                                  onChange={(e) => {
                                    setSearchValue(e.target.value);
                                    setSearchFieldError("");
                                  }}
                                  className={`me-3 ${
                                    searchFieldError ? "is-invalid" : ""
                                  }`}
                                  disabled={true}
                                />{" "}
                              </Col>{" "}
                            </Row>
                          )}
                          <>
                            {!isSearchBarVisible && (
                              <>
                                <Stepper
                                  activeTab={
                                    storedData?.customerInfo?.customerId ? 2 : 1
                                  }
                                  step1Desc={`Customer Search`}
                                  onClickStep1={() => {}}
                                  step2Desc={`Reservation Details`}
                                  onClickStep2={() => {}}
                                  noCurrsor={true}
                                />
                                <Row>
                                  {/* <div className=" mb-2">
                                  <p className="rv-page-title fs-5 fw-semibold p-1">
                                    {"Search Customer"}
                                  </p>
                                </div> */}
                                  {/* <Col
                                  lg={8}
                                  className="d-flex align-items-center"
                                > */}
                                  <div className="row mt-4">
                                    <div className="col-xl-7 col-md-6 text-md-end mx-auto d-flex align-items-center">
                                      <Input
                                        placeholder="Enter the Customer ID"
                                        value={searchValue}
                                        onChange={(e) => {
                                          setSearchValue(e.target.value);
                                          setSearchFieldError("");
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            e.preventDefault(); // Prevent form submit
                                            handleSearch(); // Trigger search manually
                                          }
                                        }}
                                        className={`me-3 ${
                                          searchFieldError ? "is-invalid" : ""
                                        }`}
                                        disabled={isCreate}
                                      />
                                      {!isCreate && (
                                        <Button
                                          type="button"
                                          onClick={handleSearch}
                                          className="btn-label rv-primary-btn rounded-1 px-2 py-1"
                                        >
                                          <i className="ri-search-line label-icon align-middle fs-16 me-2 me-3"></i>
                                          <span className="ps-4 ms-3 me-1">
                                            Search
                                          </span>
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                  {/* </Col> */}
                                </Row>
                              </>
                            )}
                            {searchFieldError && (
                              <p className="text-danger ms-3 ">
                                {searchFieldError}
                              </p>
                            )}
                          </>
                          {storedData?.customerInfo?.customerId ? (
                            <>
                              <Row>
                                <Col lg={12}>
                                  <div className="border border-radius-1 p-3 mt-4">
                                    <Row>
                                      <div className=" mb-2">
                                        <Label className="rv-page-title fs-5 fw-semibold">
                                          {"Customer Details"}
                                        </Label>
                                      </div>
                                      <Col lg={6}>
                                        <Row className="mb-3">
                                          <Col lg={4} md={6}>
                                            <Label className="rv-form-label">
                                              Customer Name
                                            </Label>
                                          </Col>
                                          <Col lg={8} md={6}>
                                            <p className="rv-form-label fw-normal">
                                              {
                                                storedData?.customerInfo
                                                  ?.firstName
                                              }{" "}
                                              {
                                                storedData?.customerInfo
                                                  ?.lastName
                                              }
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col lg={4} md={6}>
                                            <Label className="rv-form-label">
                                              Contact No
                                            </Label>
                                          </Col>
                                          <Col lg={8} md={6}>
                                            <p className="rv-form-label fw-normal">
                                              {formatPhoneNumber(
                                                `${storedData?.customerInfo?.dialCode}${storedData?.customerInfo?.mobile}`
                                              )}
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg={4} md={6}>
                                            <Label className="rv-form-label">
                                              Email
                                            </Label>
                                          </Col>
                                          <Col lg={8} md={6}>
                                            <p className="rv-form-label fw-normal">
                                              {storedData?.customerInfo?.email}
                                            </p>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col lg={6}>
                                        <Row className="mb-3">
                                          <Col lg={4} md={6}>
                                            <Label className="rv-form-label">
                                              Address
                                            </Label>
                                          </Col>
                                          <Col lg={8} md={6}>
                                            <p className="rv-form-label fw-normal">
                                              {
                                                storedData?.customerInfo
                                                  ?.addressLine1
                                              }{" "}
                                              {
                                                storedData?.customerInfo
                                                  ?.addressLine2
                                              }
                                            </p>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg={4} md={6}>
                                            <Label className="rv-form-label">
                                              ID Token Type{" "}
                                              <span style={{ color: "red" }}>
                                                *
                                              </span>
                                            </Label>
                                          </Col>
                                          <Col
                                            lg={8}
                                            md={6}
                                            style={{ marginTop: "-6px" }}
                                          >
                                            <SelectField
                                              id="idTokenType"
                                              value={
                                                initialValues?.idTokenType
                                                  ?.value?.value
                                                  ? attributeOptions?.filter(
                                                      (idTokenType) =>
                                                        idTokenType?.value ===
                                                        initialValues
                                                          ?.idTokenType?.value
                                                    )
                                                  : values.idTokenType
                                              }
                                              className={
                                                (touched.idTokenType &&
                                                  !values.idTokenType) ||
                                                false
                                                  ? "error-input"
                                                  : ""
                                              }
                                              handleChange={(
                                                selectedOption
                                              ) => {
                                                setSelectedAttribute(
                                                  selectedOption
                                                ),
                                                  setFieldValue(
                                                    "idTokenType",
                                                    selectedOption,
                                                    false
                                                  ),
                                                  setFieldTouched(
                                                    "idTokenType",
                                                    false
                                                  );
                                              }}
                                              options={attributeOptions}
                                              placeholder="Select an Attribute"
                                              isDisabled={isEdit || !storedData}
                                              isRVStyle={true}
                                            />
                                            {errors.idTokenType &&
                                            !values.idTokenType &&
                                            touched.idTokenType ? (
                                              <p className="text-danger error">
                                                {errors.idTokenType}
                                              </p>
                                            ) : null}
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                    <Row className="mt-3 mb-2"></Row>
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <div className="border border-radius-1 p-3 my-4">
                                    <div className=" mb-2">
                                      <Label className="rv-page-title fs-5 fw-semibold">
                                        {"Reservation Details"}
                                      </Label>
                                    </div>

                                    <Row className="gy-4" lg={12}>
                                      <Col xxl={4} md={6}>
                                        <div className="">
                                          <Label
                                            className="rv-form-label"
                                            htmlFor="StartTime"
                                          >
                                            Station{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </Label>
                                          <SelectField
                                            id="stationSelect"
                                            className={
                                              (touched.station &&
                                                !values.station) ||
                                              false
                                                ? "error-input"
                                                : ""
                                            }
                                            value={
                                              initialValues?.station.value
                                                ? updatedStations?.filter(
                                                    (station) =>
                                                      station.value ===
                                                      initialValues.station
                                                        .value
                                                  )
                                                : values.station
                                            }
                                            handleChange={(selectedOption) => {
                                              setSelectedStation(
                                                selectedOption
                                              ),
                                                setFieldValue(
                                                  "station",
                                                  selectedOption,
                                                  false
                                                ),
                                                setFieldTouched(
                                                  "station",
                                                  false
                                                );
                                            }}
                                            options={updatedStations}
                                            placeholder="Select"
                                            isDisabled={
                                              isEdit || !values.idTokenType
                                            }
                                            isRVStyle={true}
                                          />
                                          {errors.station &&
                                          !values.station &&
                                          touched.station ? (
                                            <p className="text-danger error">
                                              {errors.station}
                                            </p>
                                          ) : null}
                                        </div>
                                      </Col>
                                      <Col xxl={4} md={6}>
                                        <div className="">
                                          <Label
                                            className="rv-form-label"
                                            htmlFor="StartTime"
                                          >
                                            Start Date & Time{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </Label>
                                          <CommonDateTimePicker
                                            className={`form-control ${
                                              touched.startTime &&
                                              !values.startTime
                                                ? "error-input"
                                                : ""
                                            }`}
                                            name="startTime"
                                            placeholder="Select"
                                            value={
                                              values.startTime
                                                ? moment(values.startTime)
                                                : null
                                            } // Convert to moment
                                            handleChange={(data) => {
                                              (values.startTime = data),
                                                handleDateTimeChangeStart(data),
                                                setFieldTouched(
                                                  "startTime",
                                                  false
                                                );
                                              setFieldValue("startTime", data);
                                              setFieldTouched(
                                                "startTime",
                                                false
                                              );
                                            }}
                                            style={
                                              values.idTokenType
                                                ? {
                                                    height: "38px",
                                                    fontSize: "0.875rem",
                                                    borderRadius: "0.5rem",
                                                  }
                                                : {
                                                    backgroundColor: "#EFF2F7",
                                                    color: "black",
                                                    cursor: "not-allowed",
                                                    height: "38px",
                                                    fontSize: "0.875rem",
                                                    borderRadius: "0.5rem",
                                                  }
                                            }
                                            format={dateTimeFormat}
                                            minDateTime={moment()}
                                            disabled={!values.idTokenType}
                                          />
                                          {errors.startTime &&
                                            touched.startTime &&
                                            !values.startTime && (
                                              <p className="text-danger error">
                                                {" "}
                                                {errors.startTime}{" "}
                                              </p>
                                            )}
                                        </div>
                                      </Col>
                                      <Col xxl={4} md={6}>
                                        <div>
                                          <Label
                                            className="rv-form-label"
                                            htmlFor="EndTime"
                                          >
                                            End Date & Time{" "}
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </Label>
                                          <CommonDateTimePicker
                                            className={`form-control ${
                                              touched.endTime && !values.endTime
                                                ? "error-input"
                                                : ""
                                            }`}
                                            name="endTime"
                                            placeholder="Select"
                                            value={
                                              values.endTime
                                                ? moment(values.endTime)
                                                : null
                                            } // Convert to moment
                                            handleChange={(data) => {
                                              (values.endTime = data),
                                                handleDateTimeChangeEnd(data),
                                                setFieldTouched(
                                                  "endTime",
                                                  false
                                                );
                                              setFieldValue("endTime", data);
                                              setFieldTouched("endTime", false);
                                            }}
                                            style={
                                              values.idTokenType
                                                ? {
                                                    height: "38px",
                                                    fontSize: "0.875rem",
                                                    borderRadius: "0.5rem",
                                                  }
                                                : {
                                                    backgroundColor: "#EFF2F7",
                                                    color: "black",
                                                    cursor: "not-allowed",
                                                    height: "38px",
                                                    fontSize: "0.875rem",
                                                    borderRadius: "0.5rem",
                                                  }
                                            }
                                            format={dateTimeFormat}
                                            minDateTime={
                                              values.startTime
                                                ? moment(values.startTime)
                                                : moment()
                                            } // Convert to moment
                                            disabled={!values.idTokenType}
                                          />
                                          {errors.endTime &&
                                            touched.endTime &&
                                            !values.endTime && (
                                              <p className="text-danger error">
                                                {" "}
                                                {errors.endTime}{" "}
                                              </p>
                                            )}
                                        </div>
                                      </Col>
                                      <Col xxl={4} md={6}>
                                        <div className="">
                                          <Label
                                            className="rv-form-label"
                                            htmlFor="evseSelect"
                                          >
                                            EVSE
                                          </Label>
                                          <SelectField
                                            id="evseSelect"
                                            value={selectedEVSE}
                                            isDisabled={true}
                                            options={evseoptions}
                                            placeholder="Select"
                                            isRVStyle={true}
                                          />
                                        </div>
                                      </Col>
                                      <Col xxl={4} md={6}>
                                        <div>
                                          <Label
                                            className="rv-form-label"
                                            htmlFor="connectorTypeSelect"
                                          >
                                            Connector Type
                                          </Label>
                                          <SelectField
                                            id="connectorTypeSelect"
                                            value={selectedConnectorType}
                                            isDisabled={true}
                                            options={connectorTypeOptions}
                                            placeholder="Select"
                                            isRVStyle={true}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="my-4 mb-5">
                                <div className="d-flex justify-content-end gap-2">
                                  <CommonButton
                                    outline={true}
                                    className={
                                      "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                                    }
                                    color={"main-color"}
                                    type={"reset"}
                                    buttonAction={() =>
                                      navigate("/reservation")
                                    }
                                    buttonText={"Cancel"}
                                    icon={
                                      <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    }
                                    btnTxtClsName={
                                      "px-2 ps-3 ms-2 me-1 fw-bold"
                                    }
                                  />
                                  <CommonButton
                                    color={"main-color"}
                                    className={
                                      "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap"
                                    }
                                    icon={
                                      <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                                    }
                                    btnTxtClsName={
                                      "px-2 ps-3 ms-2 me-1 fw-bold"
                                    }
                                    type={"submit"}
                                    buttonText={"Submit"}
                                  />
                                </div>
                              </Row>
                            </>
                          ) : (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: "400px" }}
                            >
                              <div className="text-center mb-2">
                                Search for a customer to create a reservation.
                              </div>
                            </div>
                          )}
                        </div>
                      </CardBody>
                    )}
                  </Col>
                </Row>
              </Container>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}
export default CreateReservations;
